import React from "react";
import { motion } from "framer-motion";
import { Globe2 } from "lucide-react";

/**
 * Card "Logistica globale" (vista trader): silhouette stilizzata del mondo.
 * Animazione leggera al primo render — fade-in scaglionato per dare un tocco
 * "premium" senza appesantire.
 */
export default function WorldMapCard() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, ease: "easeOut" }}
      className="bg-white border border-ink/10 p-8 rounded-sm"
      data-testid="trader-worldmap"
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.1 }}
        className="flex items-center justify-between"
      >
        <div className="text-[11px] tracking-[0.3em] uppercase text-slate1">Logistica globale</div>
        <Globe2 size={16} className="text-gold" />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 0.94 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.9, delay: 0.25, ease: [0.22, 1, 0.36, 1] }}
        className="mt-6 flex items-center justify-center"
      >
        <img
          src="/world-map.png"
          alt="Copertura logistica internazionale"
          className="w-full max-w-md h-auto select-none transition-transform duration-700 hover:scale-[1.02]"
          loading="lazy"
          draggable={false}
          data-testid="trader-worldmap-img"
        />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 6 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.55 }}
      >
        <div className="mt-6 h-px bg-ink/10" />
        <div className="mt-5 text-sm text-ink leading-relaxed">
          Deposito attrezzato e <span className="font-medium">spedizione in tutto il mondo</span> · gestione doganale e installazione on-site.
        </div>
      </motion.div>
    </motion.div>
  );
}
